import { DropdownOption } from '@components/dropdown/dropdown.types';
import { ChallengePlaylistReturn } from '@services/gateways/combined-assign-gateway/combined-assign-gateway.types';

export const DEFAULT_PLAYLIST_ID = 0;

export const defaultPlaylistItem = {
    id: DEFAULT_PLAYLIST_ID,
    activityIds: []
};

export type ChallengesPlaylist = Pick<ChallengePlaylistReturn, 'id' | 'activityIds'>;

export type PlaylistFilterDropdownOption = Pick<DropdownOption, 'label' | 'value' | 'disabled'>;

export type PlaylistFilterBodyProps = {
    items: PlaylistFilterDropdownOption[]
    onClickHandler: (value: number) => void
    setIsOpen: (isOpen: boolean) => void
    selectedPlaylist: number
};

export type PlaylistFilterProps = {
    selectedPlaylist: number
    onSelectHandler: (playlist: ChallengePlaylistReturn) => void
    onResetHandler: () => void
};
